var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":true}},[_c('alert-message'),(!_vm.isShowAlert)?_c('div',[_vm._v("EdiRequest Authentication Loading...")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }